import react, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { onValue, ref, set } from 'firebase/database';
import ActionButton from 'src/features/motioning/ActionButton';
import Header from 'src/features/motioning/Header';
import MotionEnd from 'src/features/motioning/MotionEnd';
import MovingAnimation from 'src/features/motioning/MovingAnimation';
import ProcessBar from 'src/features/motioning/ProcessBar';
import RestAnimation from 'src/features/motioning/RestAnimation';
import database from 'src/libraries/firebase';
import { IRobot } from 'src/types/firebase';
import styled from 'styled-components';

const MotioningStyled = styled.div<{
  status: Pick<IRobot, 'setting'>['setting']['status'];
}>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100vh;
  background: linear-gradient(#ededed, #f8f8f8);
`;

export default function Motioning() {
  const { id } = useParams();
  const [robot, setRobot] = useState<IRobot | undefined>(undefined);
  const robotSettingRef = ref(database, 'health_robot/setting/status');
  const robotHistoryRef = ref(database, 'health_robot/history');
  const navigate = useNavigate();

  useEffect(() => {
    const robotRef = ref(database, 'health_robot');
    onValue(robotRef, snapshot => {
      const robot = snapshot.val() as IRobot;
      setRobot(robot);
    });
  }, []);

  useEffect(() => {
    if (robot?.setting.status === 'REST') {
      setTimeout(() => {
        set(robotSettingRef, 'MEASURE');
      }, 30000);
    }

    if (robot?.setting.status === 'MOVING') {
      setTimeout(() => {
        set(robotSettingRef, 'MEASURE');
      }, 7000);
    }
  }, [robot?.setting.status]);

  if (!robot) {
    return <></>;
  }

  return (
    <MotioningStyled status={robot.setting.status}>
      <Header robot={robot} />
      {robot.setting.status === 'MOVING' && <MovingAnimation />}
      {robot.setting.status === 'REST' && <RestAnimation />}

      {['MEASURE'].includes(robot.setting.status) && (
        <ProcessBar robot={robot} />
      )}
      {['MEASURE_END'].includes(robot.setting.status) && <MotionEnd />}
      <ActionButton
        onClick={async () => {
          await Promise.all([
            set(robotSettingRef, 'READY'),
            set(robotHistoryRef, []),
          ]);
          navigate('/motion');
        }}
      />
    </MotioningStyled>
  );
}
